import React from 'react';
import { PointCard } from '../components/PointCard';
import ScrollMenu from 'react-horizontal-scrolling-menu';

const MenuItem = ({ point, selected, small }) => {
  return <PointCard point={point} selected={selected} small={small} />;
};

export const Menu = (points, selected, small = false) =>
  points.map((point) => {
    return <MenuItem point={point} key={point.pointId} selected={selected} small={small} />;
  });

const PointsSlider = (props) => {
  const { points, activePoint, setActivePoint, small } = props;
  if (!Array.isArray(points)) {
    return null;
  }

  const foundPoints = Menu(points, activePoint, small);

  return (
    <ScrollMenu
      data={foundPoints}
      arrowLeft={null}
      arrowRight={null}
      alignCenter={false}
      wheel={false}
      selected={activePoint}
      onSelect={setActivePoint}
      hideArrows={true}
      innerWrapperStyle={{ width: '100vw' }}
    />
  );
};

export default PointsSlider;
